/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SkillAcquisitionObjectiveModel } from '../../models/skill-acquisition-objective-model';

export interface GetPatientSkillAcquisitionObjectives$Params {
  patientID?: number;
}

export function GetPatientSkillAcquisitionObjectives(http: HttpClient, rootUrl: string, params?: GetPatientSkillAcquisitionObjectives$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SkillAcquisitionObjectiveModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientSkillAcquisitionObjectives.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SkillAcquisitionObjectiveModel>>;
    })
  );
}

GetPatientSkillAcquisitionObjectives.PATH = '/api/Supervisor/GetPatientSkillAcquisitionObjectives';
